import { combineReducers } from 'redux'
import cart from './cart'
import { markets, shippingSettings } from './markets'
import products from './products'

const reducers = () =>
	combineReducers({
		cart,
		products,
		shippingSettings,
		markets
	})

export default reducers
